const statusOf = (error: unknown): number | null => {
  if (typeof error !== 'object' || error === null) return null;
  const { status, statusCode } = error as { status?: unknown; statusCode?: unknown };
  if (typeof status === 'number') return status;
  if (typeof statusCode === 'number') return statusCode;
  return null;
};

/**
 * A query `retry` that tries a failed fetch up to three more times when that
 * could help: a server error, or no response at all (fetch rejects with a
 * `TypeError`). A 4xx would get the same answer again, and retrying a throttled
 * request (429) only extends the throttle. So would a response the client could
 * not use (a payload failing its schema, an HTML login page): a fetcher that
 * means a status to be retried throws it with one.
 */
export const retryTransientFailure = (failureCount: number, error: unknown): boolean => {
  if (failureCount >= 3) return false;
  const status = statusOf(error);
  return status === null ? error instanceof TypeError : status >= 500;
};
